export default __webpack_public_path__ + "static/media/at.3f24aadd.svg";